module.exports = __webpack_public_path__ + "img/H3.da397e4b.png";